import * as JwtDecode from 'jwt-decode'

import Api from 'services/Api'
import { createErrorNotification } from 'store/actions/notifications'
import { setLoggedOut } from 'store/actions/auth'

export const launchPunchTerminal = locationId => {
  return async dispatch => {
    // Generates a punch token for the terminal
    const { success, token } = await Api.post('/punch/token', { location: locationId })
    if (!success || !token) return dispatch(createErrorNotification())

    // Set the token into the local storage
    localStorage.setItem('token', token)
    localStorage.removeItem('renewToken')
    Api.defaults.headers.common['token'] = localStorage.getItem('token')

    // Decode the token to access it's informations
    const decodedToken = JwtDecode(token)
    // Update the store with the Token info and start the punch terminal
    dispatch({ type: 'LAUNCH_PUNCH_TERMINAL', decodedToken, token })
  }
}

export const loginEmployee = userInfo => {
  return dispatch => {
    dispatch({ type: 'OPEN_SESSION', userInfo })
  }
}

export const logoutEmployee = () => {
  return async dispatch => {
    dispatch({ type: 'CLOSE_SESSION' })
  }
}

export const setSelectedShift = selectedShift => {
  return dispatch => {
    dispatch({ type: 'SET_SELECTED_SHIFT', selectedShift })
  }
}
export const setPunchCard = punchCard => {
  return dispatch => {
    dispatch({ type: 'SET_PUNCH_CARD', punchCard })
  }
}

export const setCurrentBreak = currentBreak => {
  return dispatch => {
    dispatch({ type: 'SET_CURRENT_BREAK', currentBreak })
  }
}

export const setCanClosePunchTerminal = () => {
  return dispatch => dispatch({ type: 'SET_CAN_CLOSE_PUNCH_TERMINAL' })
}

export const closePunchTerminal = () => {
  return async (dispatch, getState) => {
    await setLoggedOut({ dispatch, getState })
    dispatch({ type: 'CLOSE_PUNCH_TERMINAL' })
  }
}
